// Copyright (c) 2017 Deere & Company

import TcsmAudits from '../../tcsm/audits/state-connector';

export default {
    component: TcsmAudits,
    name: 'AUDITS',
    path: 'audits'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/audits.js